import { Injectable } from '@angular/core';
import { timeout } from 'rxjs';

import * as toastr from 'toastr'

@Injectable({
  providedIn: 'root',
})
export class ToastrService {


  constructor(){
    toastr.options.timeOut = 8000
    //toastr.options.progressBar = true
  }

  error(msg : string = ""){
    toastr.error(msg, 'Erreur')
  }

  success(msg : string = ""){
    toastr.success(msg, 'Succes')
  }

  info(msg : string = ""){
    toastr.info(msg, 'Info')
  }

  war(msg : string = ""){
    toastr.warning(msg, 'Attention')
  }


}
